import { GetOneParams, GetOneResult, UpdateParams } from "react-admin";
import { z } from "zod";
import { getAuthenticatedServerClient, schemas } from "../api/server.api";
import { AbstractDataProvider } from "./AbstractDataProvider";

export const WorkTimeDayEnum = z.enum(["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]);
export type WorkTimeDay = z.infer<typeof WorkTimeDayEnum>;

export type WorkTimes = z.infer<typeof schemas.WorkTimesDto> & { id: string };

class InstructorWorkTimesProvider extends AbstractDataProvider<WorkTimes> {
  async getOne(_: string, { id }: GetOneParams): Promise<GetOneResult<WorkTimes>> {
    const serverClient = await getAuthenticatedServerClient();
    const workTimes = await serverClient.getInstructorWorkTimes({ params: { id } });
    return { data: { id, ..._emptyWorkTimes(), ...workTimes } };
  }

  async update(_: string, { id, data, previousData }: UpdateParams<WorkTimes>): Promise<GetOneResult<WorkTimes>> {
    const dto = schemas.WorkTimesDto.parse({ ...previousData, ...data });
    const serverClient = await getAuthenticatedServerClient();
    await serverClient.setInstructorWorkTimes(dto, { params: { id } });
    return { data: { id, ...dto } };
  }
}

export const instructorWorkTimesProvider = new InstructorWorkTimesProvider();

function _emptyWorkTimes(): Omit<WorkTimes, "id"> {
  return {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
  };
}
